import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output, ViewChild
} from '@angular/core';
import {DetectMethodChanges} from "../../utils";
import {ApgPortfolio} from "../../adjustment-pricing-grid/model/ApgPortfolio";
import {HgHedgePositionsComponent} from "./hedge-positions/hg-hedge-positions.component";
import {HgPortfolioSelectorComponent} from "./portfolio-selector/hg-portfolio-selector.component";
import {HgPortfolioPositionsComponent} from "./portfolio-positions/hg-portfolio-positions.component";
import {ServiceConfiguration} from "../../adjustment-pricing-grid/services/ServiceConfiguration";
import {HedgePositionsService} from "./hedge-positions/hedge-positions.service";

@Component({
    selector: 'ets-hg-positions-section',
    templateUrl: 'hg-positions-section.component.html',
    styleUrls: [
        './hg-positions-section.component.scss',
        '../hedging-grid-common-styles.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class HgPositionsSectionComponent implements OnInit {
    constructor(
        private readonly _changeDetector: ChangeDetectorRef,
        private readonly _hedgePositionsService: HedgePositionsService
    ) {
    }

    @Input() collapsed: boolean;

    @Output() toggleCollapsed = new EventEmitter();

    @Output() portfolioSelected = new EventEmitter<ApgPortfolio>();

    @ViewChild(HgHedgePositionsComponent) hedgePositionsCmp: HgHedgePositionsComponent;

    // CR-20260922-001 — reached by the Hedging Grid for the Action Board deep link.
    @ViewChild(HgPortfolioSelectorComponent) portfolioSelectorCmp: HgPortfolioSelectorComponent;

    @ViewChild(HgPortfolioPositionsComponent) portfolioPositionsCmp: HgPortfolioPositionsComponent;

    selectedPortfolio: ApgPortfolio;

    ngOnInit() {
    }

    @DetectMethodChanges()
    onToggleCollapsed() {
        this.toggleCollapsed.emit();
    }

    @DetectMethodChanges({isAsync: true})
    async onPortfolioSelected(args: ApgPortfolio) {

        this.selectedPortfolio = args;

        this.portfolioSelected.emit(args);

        await this.hedgePositionsCmp.onPortfolioSelected(args);

        await this.portfolioPositionsCmp.onPortfolioSelected(args);
    }
}